import Vue from 'vue';
import phoneHelper from 'Assets/js/components/phoneHelper';

const mutations = {
  setAddedContacts(state, input) {
    state.addedContacts = input;
  },
  setB2bUserList(state, users) {
    const list = Array.isArray(users) ? users : [];
    if (Object.prototype.hasOwnProperty.call(state.user, 'b2bUserList')) {
      state.user.b2bUserList = list;
      return;
    }
    Vue.set(state.user, 'b2bUserList', list);
  },
  addToken(state, token) {
    state.user.token = token;
  },
  removeToken(state) {
    state.user.token = null;
  },
  setUser(state, user) {
    delete user.wishlist;
    if (!Array.isArray(user.b2bUserList)) {
      user.b2bUserList = state.user?.b2bUserList || [];
    }

    try {
      // Split phone prefix and phone number
      const { prefix, number } = phoneHelper.splitPhoneNumber(user.phone);
      user.phone_prefix = prefix;
      user.phone = number;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('mutations.user: unable to parse phone number', [
        user.phone,
        e
      ]);
    }

    state.user = user;
  },
  setEmail(state, email) {
    state.user.email = email;
  },
  setFirstName(state, firstName) {
    state.user.firstName = firstName;
  },
  setLastName(state, lastName) {
    state.user.lastName = lastName;
  },
  setLoadedUser(state, input) {
    state.loaded = input;
  },
  setMenuLoaded(state, input) {
    state.menuLoaded = input;
  }
};

export default mutations;
